import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractPageComponent, DocumentReference, SdkDictionaryService } from '@dsivd/prestations-ng';
import { first, tap } from 'rxjs/operators';

import { BusinessForm } from '../../model/business-form';
import { CadorDocumentReference } from '../../model/cador-document-reference';
import { CadorReference } from '../../model/cador-reference';
import { ImpFoehnRecapSection, ImpFoehnRecapSectionElement } from '../../model/imp-foehn-recap-section';
import { LibelleConfigurable } from '../../model/libelle-configurable';
import { RefCadorService } from '../../services/ref-cador/ref-cador.service';
import { ElementUtils } from '../../utils/element.utils';

@Component({
    templateUrl: './request-procuration-page.component.html'
})
export class RequestProcurationPageComponent extends AbstractPageComponent<BusinessForm> implements OnInit {

    libelles: LibelleConfigurable[];
    wholeValue = ElementUtils.wholeValue;

    documentTypes: CadorReference[];
    docSelected: CadorReference[] = [];
    listeDocumentsPossibles: CadorDocumentReference[] = [];

    constructor(
        protected activatedRoute: ActivatedRoute,
        private dictionaryService: SdkDictionaryService,
        private refCadorService: RefCadorService
    ) {
        super(activatedRoute);

        this.libelles = this.refCadorService.getLibellesSync();
        this.loadData();
    }

    ngOnInit(): void {
        super.ngOnInit();
        super.setPageTitle(this.dictionaryService.getKeySync('request-procuration.title'));
        this.form.requestSummary.approveGeneralConditions = null;
    }

    getRenderHTML(isStep7: boolean): any {
        const libelle = this.libelles.find(value => value.valeur === this.form.requestOrigin.libelleConfigurable.valeur);

        if (libelle && isStep7) {
            return libelle.libelleEtape7;
        } else if (!(libelle && isStep7)) {
            return libelle.libelleEtape8;
        } else {
            return '';
        }
    }

    onDocumentsAdded(): void {
        // je vide et je rerempli.
        this.form.attachments.listeDocuments = [];
        this.listeDocumentsPossibles.forEach(d => {
            this.form.attachments.listeDocuments.push(d);
        });
    }

    isBoxChecked(id: number): boolean {
        return this.docSelected.some(sd => sd.id === id);
    }

    newForm(): BusinessForm {
        return new BusinessForm();
    }

    send(goToNextPage?: boolean): void {
        this.beforeSend(false, goToNextPage);
    }

    previous(): void {
        this.beforeSend(true, false);
    }


    private loadData(): void {
        // libellés
        this.libelles = this.refCadorService.getLibellesSync();

        // types d'attachements possibles
        this.documentTypes = this.refCadorService.getDocumentTypesSync();

        // récupérer les documents déjà saisis, pour les réafficher la page
        this._gesdemEventService.formInitializationObservable().pipe(
            first(),
            tap((form: BusinessForm) => {
                // on construit une liste de types de documents, avec à chaque fois
                // une liste de documents uploadés, associées à chaque type.
                this.listeDocumentsPossibles = [];
                this.documentTypes.forEach(d => {
                    // Si déjà des documents dans le formulaire, les mettre dans listeDocuments
                    // pour ré-afficher les documents déjà chargés.
                    if (form.attachments.listeDocuments.some(fd => fd.cadorDocumentType.id === d.id)) {
                        const odr: CadorDocumentReference = form.attachments.listeDocuments.find(fd => fd.cadorDocumentType.id === d.id);
                        this.listeDocumentsPossibles.push(odr);
                        if (odr.documentReference.length > 0) {
                            this.docSelected.push(odr.cadorDocumentType);
                        }
                    } else {
                        const dr: DocumentReference[] = [];
                        const odr: CadorDocumentReference = new CadorDocumentReference(dr, d);
                        this.listeDocumentsPossibles.push(odr);
                    }
                });
            })
        ).subscribe();
    }

    private beforeSend(previous: boolean, goToNextPage: boolean): void {
        if (previous) {
            super.previous();
        } else {
            this.buildRecap();
            this.removeNotChecked();
            super.send(goToNextPage);
        }
    }

    /**
     * Nourrir le composant <foehn-recap-section />
     * @private
     */
    private buildRecap(): void {
        this.form.attachments.recap = [];
        this.form.attachments.listeDocuments.forEach(d => {
            if (d.documentReference.length > 0) {
                const r: ImpFoehnRecapSection = new ImpFoehnRecapSection(d.cadorDocumentType.valeur);
                if (d.documentReference.length > 0) {
                    d.documentReference.forEach(t => {
                        const e: ImpFoehnRecapSectionElement = new ImpFoehnRecapSectionElement('', t.filename);
                        r.elements.push(e);
                    });
                }
                this.form.attachments.recap.push(r);
            }
        });

    }

    /**
     * Faire le ménage avant de passer au suivant : si box du type de document non checkée,
     * on vide les docs associés.
     * @private
     */
    private removeNotChecked(): void {
        this.form.attachments.listeDocuments.forEach(d => {
            // Si box non checkée, vider la liste des documents.
            if (!this.docSelected.some(sd => sd.id === d.cadorDocumentType.id)) {
                d.documentReference = [];
            }
        });
    }
}
